module.exports = __webpack_public_path__ + "static/img/icon_overlook.4f1c0551.svg";